import React from "react";
import { MarketSentimentLiveContainer } from "./styles";
import Body from "./components/Body";

function MarketSentimentLive() {
  console.log(`
  Market Sentiment v1.0.0.0
  Changelog:
  - Prepared for the public release
  - Integrated GA
  - Integrated socials and TOS
  `);
  return (
    <MarketSentimentLiveContainer>
      <Body />
    </MarketSentimentLiveContainer>
  );
}
export default MarketSentimentLive;
